export default __webpack_public_path__ + "static/media/image_store.773ef9dd.svg";